import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import formationsBusinessDeveloperStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'formationsBusinessDeveloper'
const customImplement: CustomStoreImplementationOptions = formationsBusinessDeveloperStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function formationsBusinessDeveloperFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('prog-05-business-dev.title', 'Formation business developer'),
        $description: $translate('prog-05-business-dev.description', 'Formez-vous au business development sur-mesure avec l\'un de nos experts Matchers pour booster votre entreprise !'),
        $publishedTime: new Date('2023-03-21T13:49:22.331Z'),
        $modifiedTime: new Date('2023-09-01T13:17:56.602Z'),
        // Constants,
        $constants: {
          blocPreviewProfilExpertTags: [
            { Nom: 'Négociation' },
            { Nom: 'PNL' },
            { Nom: 'Prospection' },
            { Nom: 'Santé' },
            { Nom: 'Management' },
            { Nom: 'Evènement' },
            { Nom: 'Négociation en centrale d\'achat' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element1Tags: [
            { Nom: 'Implémentation de process' },
            { Nom: 'SaaS' },
            { Nom: 'Stratégie outbound' },
            { Nom: 'Management' },
            { Nom: 'Coaching' },
            { Nom: 'Closing' },
            { Nom: 'Sport' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element2Tags: [
            { Nom: 'Chasse' },
            { Nom: 'Argumentaire' },
            { Nom: 'SaaS' },
            { Nom: 'Négociation' },
            { Nom: 'Vente complexe' },
            { Nom: 'Ciblage' },
            { Nom: 'Cycle de vente' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element3Tags: [
            { Nom: 'Cold calling' },
            { Nom: 'Processus de vente' },
            { Nom: 'Scraping' },
            { Nom: 'Stratégie commerciale' },
            { Nom: 'CRM' },
            { Nom: 'Lemlist' },
            { Nom: 'Dropcontact' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          dropDownFormationArguments: [
            { Text: '<ul><li>Définir sa stratégie commerciale.</li></ul>' },
            { Text: '<ul><li>Analyser son marché.</li></ul>' },
            { Text: '<ul><li>&nbsp;Identifier les stratégies commerciales possibles pour développer son entreprise avec un SWOT.</li></ul>' },
            { Text: '<ul><li>Analyser la concurrence par le modèle de Porter.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element4Arguments: [
            { Text: '<ul><li>Définir son Plan d’action commercial.</li></ul>' },
            { Text: '<ul><li>Déterminer des objectifs SMART.</li></ul>' },
            { Text: '<ul><li>Définir les indicateurs de performance à suivre.</li></ul>' },
            { Text: '<ul><li>Suivre et ajuster mon Plan d’action commercial.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element5Arguments: [
            { Text: '<ul><li>Identifier et cibler ses clients type grâce à la technique des personas.</li></ul>' },
            { Text: '<ul><li>Cartographier ses canaux d’acquisition pour une personnalisation du parcours client.</li></ul>' },
            { Text: '<ul><li>Construire et renforcer ses arguments commerciaux</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element6Arguments: [
            { Text: '<ul><li>Rédiger un mailing type selon ses cibles.&nbsp;</li></ul>' },
            { Text: '<ul><li>Créer une campagne d’emailing.</li></ul>' },
            { Text: '<ul><li>Créer une campagne de micro-mailing.</li></ul>' },
            { Text: '<ul><li>Assimiler les bases de la délivrabilité email et les bonnes pratiques d’envoi.</li></ul>' },
            { Text: '<ul><li>Mettre en place les outils de suivi et analyser les résultats.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element7Arguments: [
            { Text: '<ul><li>Process et tips de hunting : comment prospecter efficacement.</li></ul>' },
            { Text: '<ul><li>Définir les meilleurs critères de pour son ciblage.</li></ul>' },
            { Text: '<ul><li>Créer des scripts de hunting &amp; closing.</li></ul>' },
            { Text: '<ul><li>Définir et rédiger les étapes de mon cycle de vente.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element8Arguments: [
            { Text: '<ul><li>Rédiger un argumentaire de vente et un scénario de démonstration.</li></ul>' },
            { Text: '<ul><li>Franchir les barrages.</li></ul>' },
            { Text: '<ul><li>Susciter l’intérêt de notre interlocuteur.</li></ul>' },
            { Text: '<ul><li>Utiliser la technique FOCA pour créer et identifier les besoins.</li></ul>' },
            { Text: '<ul><li>Utiliser la technique de l’entonnoir : l’enchaînement des sujets porteurs de plus-value.</li></ul>' },
            { Text: '<ul><li>Mettre en pratique la technique d’écoute active.</li></ul>' },
            { Text: '<ul><li>Utiliser la technique des accords partiels pour isoler les résistances.</li></ul>' },
            { Text: '<ul><li>User de communication persuasive.</li></ul>' },
            { Text: '<ul><li>Savoir traiter les objections avec la technique QRAC.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element9Arguments: [
            { Text: '<ul><li>Susciter l’adhésion et construire un challenge commercial pour son équipe.</li></ul>' },
            { Text: '<ul><li>Gérer le portefeuille et fidéliser les clients.</li></ul>' },
            { Text: '<ul><li>Identifier les indicateurs opérationnels à mettre en place pour chaque type d\'action commerciale.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>
        },
        // Data,
        $info: { prog05BusinessDev: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      blocPreviewProfilExpertClick () {
        openUrl('https://www.matchers.fr/expert/398', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element1Click () {
        openUrl('https://www.matchers.fr/expert/135', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      voirClick () {
        openUrl('https://www.matchers.fr/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return formationsBusinessDeveloperFactory(storeId)()
}

export const formationsBusinessDeveloperRaw = formationsBusinessDeveloperFactory()
export const formationsBusinessDeveloper = () => formationsBusinessDeveloperRaw() as MergeCustomStore<typeof formationsBusinessDeveloperStoreCustom.instance>
